import i18next, { Resource } from 'i18next';
import translationEN from './translations/en.json';
import translationENGB from './translations/en-gb.json';
import translationFR from './translations/fr.json';
import translationDE from './translations/de.json';
import translationES from './translations/es.json';
import translationHI from './translations/hi.json';
import translationIT from './translations/it.json';
import translationJA from './translations/ja.json';
import translationKO from './translations/ko.json';
import translationPT from './translations/pt.json';
import translationRU from './translations/ru.json';
import translationAR from './translations/ar.json';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const debug = process.env.NODE_ENV === 'development';

const resources: Resource = {
  en: {
    translation: translationEN,
  },
  'en-GB': {
    translation: translationENGB,
  },
  fr: {
    translation: translationFR,
  },
  de: {
    translation: translationDE,
  },
  es: {
    translation: translationES,
  },
  hi: {
    translation: translationHI,
  },
  it: {
    translation: translationIT,
  },
  ja: {
    translation: translationJA,
  },
  ko: {
    translation: translationKO,
  },
  pt: {
    translation: translationPT,
  },
  ru: {
    translation: translationRU,
  },
  ar: {
    translation: translationAR,
  },
};

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug,
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: false,
  });

export default i18next;
